// extracted by mini-css-extract-plugin
export default {"Buttons":"pDofYtr70z9x7jhl6wwq","Button":"QmTPPAV6K7gzHzpQCUmy"};